'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _from = require('rxjs/observable/from');

var _operators = require('rxjs/operators');

var _isPlainObject = require('../core/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeToRender(ob) {
  Object.assign(ob, {
    render: function render(callback) {
      ob = ob.pipe((0, _operators.map)(callback));
      return _react2.default.createElement(AsyncComponent, { observable: ob });
    }
  });
  var lift = ob.lift;
  ob.lift = function (operator) {
    var newOb = lift.call(this, operator);
    mergeToRender(newOb);
    return newOb;
  };
  return ob;
}

var AsyncComponent = (_temp2 = _class = function (_React$PureComponent) {
  (0, _inherits3.default)(AsyncComponent, _React$PureComponent);

  function AsyncComponent() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AsyncComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AsyncComponent.__proto__ || Object.getPrototypeOf(AsyncComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      children: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  // #! 把数据转成observable


  (0, _createClass3.default)(AsyncComponent, [{
    key: 'subscribe',
    value: function subscribe() {
      var _this2 = this;

      this._subscription = this.props.observable.subscribe(function (children) {
        if (_this2.mounted) {
          _this2.setState({ children: children });
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.subscribe();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.observable !== prevProps.observable) {
        this._subscription.unsubscribe();
        this.subscribe();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      this._subscription.unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.children;
    }
  }]);
  return AsyncComponent;
}(_react2.default.PureComponent), _class.propTypes = {
  observable: _propTypes2.default.object.isRequired }, _class.observable = function (ob) {
  if (Object(ob) !== ob || (0, _isPlainObject2.default)(ob)) {
    return mergeToRender((0, _from.from)(Promise.resolve(ob)));
  } else {
    return mergeToRender((0, _from.from)(ob));
  }
}, _temp2);
exports.default = AsyncComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/damo/asyncComponent.jsx
// module id = 127
// module chunks = 0